var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-manager"},[_c('TransitionGroup',{attrs:{"name":"toast","tag":"div"}},_vm._l((_vm.ToastHandler.toasts),function(toast){return _c('Toast',{key:toast.id,attrs:{"toast":toast}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }